<p-dialog [(visible)]="visible" (onHide)="onDialogHide()" [modal]="true" [style]="{'width': '800px', 'height': '500px'}"
		   appendTo="body">

	<p-header>
		<span>Select Layout Settings</span>
	</p-header>

	<layout-settings [target]="target" [allowManualLayout]="false"></layout-settings>

	<p-footer>
		<button type="button" pButton icon="fa fa-check" [disabled]="!enableOk" (click)="onOkClicked()" label="OK"></button>
		<button type="button" pButton icon="fa fa-close" (click)="onCancelClicked()" label="Cancel"></button>
	</p-footer>

</p-dialog>
